// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EoynY","footerTitle":"Footer_footerTitle__wKUAc","footerLink":"Footer_footerLink__URxEK"};